import { api } from '@/services'

async function useClient(clientId: string) {
    const Response = await api
        .get(`/Client/GetClienteById?id=${clientId}`)
        .then((resp) => {
            if (resp.status === 200) {
                return resp.data
            } else {
                return {
                    error: true,
                    message: 'Não foi possível encontrar o cliente.'
                }
            }
        })
        .catch((error) => {
            return {
                error: true,
                message: 'Falha ao buscar o cliente.'
            }
        })
    return Response
}

export { useClient }
